import { render, staticRenderFns } from "./LxwmView.vue?vue&type=template&id=45abde1b&scoped=true&"
import script from "./LxwmView.vue?vue&type=script&lang=js&"
export * from "./LxwmView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45abde1b",
  null
  
)

export default component.exports